import { StackingStrategyBase } from './base/stacking-strategy-base';

export class StackingStrategy extends StackingStrategyBase { }